import { storage } from "@utils:token-storage";

export const Logout = () => {
  storage.clearToken();
  window.location.assign(window.location.origin as unknown as string);

  return null;
};
